import { render } from "./createBoard.vue?vue&type=template&id=50afe60f"
import script from "./createBoard.vue?vue&type=script&lang=js"
export * from "./createBoard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__